import request from "helper/request";

const companySettingsApi = {
  // Get company profile (includes logo)
  getProfile: () => {
    return request.get("v1/client/profile");
  },

  // Upload company logo
  uploadLogo: (formData) => {
    return request.post("v1/client/logo", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  // Get company logo
  getLogo: () => {
    return request.get("v1/client/logo");
  },

  // Check if client has specific entitlement
  getEntitlement: (entitlementId) => {
    return request.get(`v1/client/entitlement/${entitlementId}`);
  },

  // Update entitlement settings
  updateEntitlementSettings: (entitlementId, settings) => {
    return request.patch(`v1/client/entitlement/${entitlementId}/settings`, settings);
  },

  // Activate entitlement for client (self-service)
  activateEntitlement: (entitlementId) => {
    return request.post(`v1/client/entitlement/${entitlementId}/activate`);
  },

  // Get client settings (including defaultRouteVisibility)
  getClientSettings: (clientId) => {
    // If clientId is provided, fetch settings for that specific client (admin mode)
    // Otherwise fetch settings for the logged-in user's client
    if (clientId) {
      return request.get(`admin/clients/${clientId}/settings`);
    }
    return request.get("v1/client/settings");
  },

  // Update client settings
  updateClientSettings: (settings) => {
    return request.patch("v1/client/settings", settings);
  }
};

export default companySettingsApi;
